import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Explore from "./pages/Explore";
import SpotDetail from "./pages/SpotDetail";
import Dashboard from "./pages/Dashboard";
import MySpots from "./pages/MySpots";
import MyBookings from "./pages/MyBookings";
import Messages from "./pages/Messages";
import AddSpot from "./pages/AddSpot";
import EditSpot from "./pages/EditSpot";
import Login from "./pages/Login";
import Acceso from "./pages/Acceso";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PaymentSuccess from "./pages/PaymentSuccess";
import AuthCallback from "./pages/AuthCallback";
import PlazafyGate from "./pages/PlazafyGate";
import Earnings from "./pages/Earnings";
import Expenses from "./pages/Expenses";
import Favorites from "./pages/Favorites";
import AppleCallback from "./pages/AppleCallback";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import CookiesPolicy from "./pages/CookiesPolicy";
import Help from "./pages/Help";
import HostPayments from "./pages/HostPayments";
import MetaPixelRouteTracker from "./components/MetaPixelRouteTracker";
import "./i18n";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <MetaPixelRouteTracker />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="explore" element={<Explore />} />
            <Route path="spots" element={<Explore />} />
            <Route path="spot/:id" element={<SpotDetail />} />
            <Route path="spots/:id" element={<SpotDetail />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="my-spots" element={<MySpots />} />
            <Route path="my-bookings" element={<MyBookings />} />
            <Route path="messages" element={<Messages />} />
            <Route path="add-spot" element={<AddSpot />} />
            <Route path="edit-spot/:id" element={<EditSpot />} />
            <Route path="profile" element={<Profile />} />
            <Route path="admin" element={<Admin />} />
            <Route path="earnings" element={<Earnings />} />
            <Route path="expenses" element={<Expenses />} />
            <Route path="favorites" element={<Favorites />} />
            <Route path="host/payments" element={<HostPayments />} />
            <Route path="payment-success" element={<PaymentSuccess />} />
            <Route path="terms" element={<Terms />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="cookies" element={<CookiesPolicy />} />
            <Route path="ayuda" element={<Help />} />
            <Route path="help" element={<Help />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/acceso" element={<Acceso />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/plazafy-gate" element={<PlazafyGate />} />
          <Route path="/auth/apple/callback" element={<AppleCallback />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
